import { MouseEvent } from "react";

interface SelectionListProps {
  options: IOption[];
  onSelect: (item: IOption) => void;
  stopPropagation?: boolean;
}

interface IOption {
  id: string;
  label: React.ReactNode;
}

const SelectionList: React.FC<SelectionListProps> = ({ options, onSelect, stopPropagation }) => {
  const handleSelect = (e: MouseEvent<HTMLDivElement, globalThis.MouseEvent>, item: IOption) => {
    onSelect(item);
    if (stopPropagation) {
      e.stopPropagation();
    }
  };

  return (
    <div>
      {options.map((item) => {
        return (
          <div
            key={item.id}
            className="w-auto min-w-32.5 whitespace-nowrap px-2 py-1.25 text-size-3.5 color-#191D26 hover:bg-#191D260D rd-1.5 flex flex-items-center flex-justify-between cursor-pointer"
            onClick={(e) => {
              handleSelect(e, item);
            }}
          >
            <div className="flex items-center h-7">
              <span>{item.label}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SelectionList;
